export const meta = {
  slug: 'introducere',
  title: 'Introducere',
  description: 'Prezentare generală a platformei și cum să utilizați această documentație.',
  icon: 'book-open',
  order: 1,
  related: ['tema', 'cont'],
};

export const images = {};

export const content = `
## Introducere

Acest manual de instrucțiuni vă va ajuta să utilizați platforma Programintrastat.ro cât mai eficient. Imaginile de referință au fost capturate din program cu tema închisă la culoare. Pentru mai multe informații legate de tema de culoare puteți consulta capitolul [Temă](/docs/tema).

Din bara laterală puteți naviga direct către capitolul care vă interesează cu un simplu click pe acesta. Dacă și după ce ați consultat acest manual nu ați putut rezolva problema ne puteți contacta la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com).
`;
